module.exports = __webpack_public_path__ + "static/media/shoyu-trans.65a79c43.png";